import { render, staticRenderFns } from "./MaTinyMCE.vue?vue&type=template&id=2c07dc27&scoped=true&"
import script from "./MaTinyMCE.vue?vue&type=script&lang=js&"
export * from "./MaTinyMCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07dc27",
  null
  
)

export default component.exports